import axios from "axios"
import { User } from "@/api/interface/user"
import { Location } from "../interface/location"
import { APIFilterParams } from "../interface/utils"

export const getUsersByLocation = (
  locationId: Location["id"]
): Promise<Array<User>> =>
  axios
    .get(`v2/users`, { params: { filter: { locationId } } })
    .then((res) => res.data.data)

export const getUsers = (params?: APIFilterParams): Promise<Array<User>> =>
  axios.get(`v2/users`, { params }).then((res) => res.data.data)

export const getUser = (userId: User["id"]): Promise<User> =>
  axios.get(`v2/users/${userId}`).then((res) => res.data.data)

export const deleteUser = (userId: User["id"]) =>
  axios.delete(`v2/users/${userId}`).then((res) => res.data.data)

export const createUser = (user: Partial<User>): Promise<User> =>
  axios.post(`v2/users`, user).then((res) => res.data.data)

export const updateUser = (user: Partial<User>): Promise<User> =>
  axios.patch(`v2/users/${user.id}`, user).then((res) => res.data.data)
